"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;
var _logger = require("@ori/logger");
var _presentationComponents = require("@ori/presentation-components");
var _react = require("react");
var _reactCoolInview = require("react-cool-inview");
var _productListClasses = _interopRequireDefault(require("../../containers/ProductListContainer/productListClasses"));
var _contexts = require("../../contexts");
var _useTranslations = require("../../hooks/useTranslations");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore next @preserve --no need to test unobserve.
const onEnter = ({
  unobserve
}) => unobserve();
const Pagination = () => {
  const logger = (0, _logger.useLogger)('Pagination');
  const [initialFetchDone, setInitialFetchDone] = (0, _react.useState)(false);
  const {
    loadedItemCount = 0,
    totalItemCount = 0,
    shouldRenderPagination = true,
    isLoadingMore,
    loadMoreItems,
    shouldLazyLoadMore
  } = (0, _contexts.useProductList)();
  const {
    translations,
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  const paginationProgress = loadedItemCount / totalItemCount * 100;
  const paginationEnd = loadedItemCount < totalItemCount;
  const {
    inView,
    observe
  } = (0, _reactCoolInview.useInView)({
    rootMargin: '100px',
    onEnter
  });
  const button = (0, _react.useMemo)(() => ({
    label: translations.showMore,
    loading: isLoadingMore,
    onClick: loadMoreItems ?? (() => {}),
    visible: paginationEnd
  }), [isLoadingMore, loadMoreItems, paginationEnd, translations.showMore]);
  (0, _react.useEffect)(() => {
    if (inView && !initialFetchDone && shouldLazyLoadMore) {
      setInitialFetchDone(true);
      loadMoreItems?.();
    }
  }, [inView, initialFetchDone, shouldLazyLoadMore, loadMoreItems]);
  if (!shouldRenderPagination) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    ref: observe,
    className: _productListClasses.default.pagination,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
      logger: logger,
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.PaginationSkeleton, {}),
      children: totalItemCount > 1 && loadMoreItems ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Pagination, {
        hideProgress: paginationEnd,
        button: button,
        infoText: formatMessage('showingXOutOfYProducts', {
          0: loadedItemCount,
          1: totalItemCount
        }),
        progress: paginationProgress
      }) : null
    })
  });
};
exports.Pagination = Pagination;
